import dynamic from 'next/dynamic';
import React from 'react';
import type { BrowseCategorySlug } from '@engage/browse-categories/models';
import { useMembersRouter as useRouter } from '@members/localization/useMembersRouter';

const SchedulePage = dynamic(
  () => import('@members/pg-schedule/components/SchedulePage'),
  {
    ssr: false,
  },
);

const YourSchedulePage = dynamic(
  () =>
    import('@members/pg-schedule/components/your-schedule/YourSchedulePageWithInvite'),
  {
    ssr: false,
  },
);

export default function Schedule() {
  const router = useRouter();
  const rawCategorySlug = router.query.categorySlug;

  // Wait for router if categorySlug is still the pattern string from Next.js
  if (typeof rawCategorySlug === 'string' && rawCategorySlug.startsWith('[')) {
    return null;
  }

  // Default to 'all' when navigating directly to /schedule or /de-DE/schedule
  const categorySlug = rawCategorySlug || 'all';

  if (categorySlug === 'yourschedule') {
    return <YourSchedulePage />;
  }

  return <SchedulePage categorySlug={categorySlug as BrowseCategorySlug} />;
}
